import styled from 'styled-components';
import { ChevronLeft } from '@styled-icons/boxicons-regular/ChevronLeft';
import { EGerdauHomeCard } from '../../components/EGerdauHome/styles';

export const DownloadCard = styled(EGerdauHomeCard)`
  & > header {
    display: flex;
    justify-content: center;
    & > img {
      width: 12rem;
    }
  }

  & > div.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;

    & > div {
      text-align: center;
      color: ${({ theme }) => theme.colors.graySubTitle};

      & > h3 {
        font-size: 0.875rem;
        margin: unset;
        font-size: 1rem;
        font-weight: bold;
      }
    }

    & > button {
      min-width: 12.5rem;
      width: 50%;
      margin: 1rem 0;
    }

    & > a {
      margin-top: 4rem;
    }
  }
`;

export const BackIcon = styled(ChevronLeft)`
  width: 1.25rem;
`;
